import { cx } from "@jugl-web/utils";
import { FC } from "react";
import {
  SupportedCustomFieldType,
  useCustomFieldTypes,
} from "../../hooks/useCustomFieldTypes";

type CustomFieldIconSize = "xs" | "sm" | "md" | "lg";

const sizeToContainerClasses: Record<CustomFieldIconSize, string> = {
  xs: "h-[14px] w-[14px]",
  sm: "h-[18px] w-[18px]",
  md: "h-6 w-6",
  lg: "h-[28px] w-[28px]",
};

const sizeToIconClasses: Record<CustomFieldIconSize, string> = {
  xs: "w-[8px] h-[8px]",
  sm: "w-[10.5px] h-[10.5px]",
  md: "",
  lg: "",
};

interface CustomFieldIconProps {
  type: SupportedCustomFieldType;
  size?: CustomFieldIconSize;
  isGrayed?: boolean;
}

export const CustomFieldIcon: FC<CustomFieldIconProps> = ({
  type,
  size = "md",
  isGrayed,
}) => {
  const { customFieldTypeToDetails } = useCustomFieldTypes();

  const { iconBackgroundColor, primaryIcon: Icon } =
    customFieldTypeToDetails[type];

  return (
    <div
      className={cx(
        "flex shrink-0 items-center justify-center rounded-full",
        sizeToContainerClasses[size],
        isGrayed && "bg-grey-600"
      )}
      style={{
        backgroundColor: !isGrayed ? iconBackgroundColor : undefined,
      }}
    >
      <Icon className={cx("text-white", sizeToIconClasses[size])} />
    </div>
  );
};
